import React from "react";

interface Props {
    className?: string;
}

export const BackIcon = ({ className = "" }: Props): JSX.Element => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_447_16952)">
                <path
                    d="M9 14L5 10L9 6"
                    stroke="#2C3E50"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 10H16C17.0609 10 18.0783 10.4214 18.8284 11.1716C19.5786 11.9217 20 12.9391 20 14C20 15.0609 19.5786 16.0783 18.8284 16.8284C18.0783 17.5786 17.0609 18 16 18H15"
                    stroke="#2C3E50"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath
                    id="clip0_447_16952">
                    <rect
                        width="24"
                        height="24"
                        fill="white" />
                </clipPath>
            </defs>
        </svg>

    );
};
